var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#stars_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__b)",
    d: "m14.467 9.414 2.706.973c.267.093.267.48 0 .573l-2.706.974a4.25 4.25 0 0 0-2.534 2.533l-.973 2.707c-.093.266-.48.266-.573 0l-.974-2.707a4.25 4.25 0 0 0-2.533-2.533l-2.707-.974c-.266-.093-.266-.48 0-.573l2.707-.973A4.25 4.25 0 0 0 9.413 6.88l.974-2.706c.093-.267.48-.267.573 0l.973 2.706a4.25 4.25 0 0 0 2.534 2.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__c)",
    d: "m26.027 15.054 2.173.786a.25.25 0 0 1 0 .467l-2.174.787a3.43 3.43 0 0 0-2.04 2.04l-.786 2.173a.25.25 0 0 1-.467 0l-.787-2.173a3.43 3.43 0 0 0-2.04-2.04l-2.173-.787a.25.25 0 0 1 0-.467l2.174-.787a3.43 3.43 0 0 0 2.04-2.04l.786-2.173a.25.25 0 0 1 .467 0l.787 2.174a3.43 3.43 0 0 0 2.04 2.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#stars_svg__d)",
    d: "m14.867 23.427 1.706.613a.19.19 0 0 1 0 .36l-1.706.613A2.63 2.63 0 0 0 13.28 26.6l-.613 1.707a.19.19 0 0 1-.36 0l-.614-1.707a2.63 2.63 0 0 0-1.586-1.587L8.4 24.4a.19.19 0 0 1 0-.36l1.707-.613a2.63 2.63 0 0 0 1.586-1.587l.614-1.707a.19.19 0 0 1 .36 0l.613 1.707c.267.747.853 1.32 1.587 1.587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "stars_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.996 7.123 5.979)scale(16.5921 15.392)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "stars_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.996 11.295 11.679)scale(13.3562 12.3901)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "stars_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(132.996 3.562 13.768)scale(10.4423 9.68698)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF922D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "stars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgStars;